<template>
  <div class="bg">
    <div class="container">
      <div class="header">
        <h3>{{ classInfo.className }}</h3>
        <!-- <img :src="classInfo.classContent" alt="" height="262px" width="100%" /> -->
      </div>
      <div class="content">
        <div class="class-detail">
          <p class="desc">{{ classInfo.classDesc }}</p>
          <div class="ors">
            <div class="orsbox gbone" @click="apply(classId)">
              <span>在线支付报名</span>
            </div>

            <div class="orsbox gbtwo" @click="applyCom(classId)">
              <span>对公汇款报名</span>
            </div>
          </div>
        </div>
        <div class="class-course card">
          <div class="class-course-header">
            <div class="car-title">
              <span>学习课程</span>
            </div>
            <div style="display: flex; align-items: center">
              <span :class="show ? 'bxk' : 'xxk'" @click="courseActive"
                >必修</span
              >
              <!-- this.xxList.length>0 -->
              <!-- @click="classInfo.xxHours == 0 ? null : courseActive2()" -->
              <span
                :class="show2 ? 'xxk' : 'bxk'"
                @click="xxList.length == 0 ? null : courseActive2()"
              >
                选修
              </span>
            </div>
          </div>
          <div class="class-course-content" v-if="show">
            <div class="item" v-for="(item, index) in bxList" :key="index">
              <img height="160px" width="100%" :src="item.courseLogo" alt="" />
              <p>{{ item.courseName }}</p>
              <div class="descs">
                <span>{{ item.courseTeacher }}</span>
                <span>{{ item.courseType }}</span>
              </div>
            </div>
          </div>
          <div class="xx" v-else>
            <el-table border :data="xxList">
              <el-table-column
                prop="courseName"
                align="center"
                label="课程名称"
              >
              </el-table-column>
              <el-table-column
                prop="courseType"
                align="center"
                label="类型"
                width="180"
              >
              </el-table-column>
              <el-table-column prop="courseHours" align="center" label="学时">
              </el-table-column>
              <el-table-column prop="courseTeacher" align="center" label="老师">
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="study-lc" v-if="classId != 46">
          <div class="lc card">
            <div class="car-title">
              <span>学习流程</span>
            </div>
            <div class="ic-contain card-box">
              <div class="lc-item">
                <img src="@/assets/image/two (5).png" alt="" />
                <span>报名</span>
              </div>
              <div class="jian">
                <img src="@/assets/image/two (4).png" alt="" class="jt1" />
              </div>
              <div class="lc-item">
                <img src="@/assets/image/two (3).png" alt="" />
                <span>听课学习</span>
              </div>
              <div class="jian">
                <img src="@/assets/image/two (4).png" alt="" class="jt1" />
              </div>
              <div class="lc-item">
                <img src="@/assets/image/two (2).png" alt="" />
                <span>参加考试</span>
              </div>
              <div class="jian">
                <img src="@/assets/image/two (4).png" alt="" class="jt1" />
              </div>
              <div class="lc-item">
                <img src="@/assets/image/two (1).png" alt="" />
                <span>打印证书</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";

export default {
  name: "index",
  data() {
    return {
      classId: "",
      show: true,
      show2: true,
      classInfo: {},
      bxList: [],
      xxList: [],
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  mounted() {},
  methods: {
    courseActive() {
      this.show = true;
      this.show2 = true;
    },
    courseActive2() {
      this.show = false;
      this.show2 = false;
    },
    getClassForId(id) {
      api.classForId(id).then((res) => {
        this.classInfo = res.data;
        console.log(this.classInfo, "我是班级");
      });
    },
    getBxxxCourse(id) {
      api.bxxxCourse(id).then((res) => {
        // console.log(res.data.list)
        res.data.list.forEach((item) => {
          if (item.courseType === 1) {
            item.courseType = "必修";
            this.bxList.push(item);
          } else {
            item.courseType = "选修";
            this.xxList.push(item);
          }
        });
      });
    },
    async apply(id) {
      let num = await api.queryAvailableNumByClassId(
        this.classInfo.classConfigId
      );
      if (!this.user) {
        this.$message.warning("请先登录后再报名");
      } else if (this.classInfo.applyEndTime < new Date().getTime()) {
        this.$message.warning("报名时间已过");
      } else if (this.classInfo.applyStartTime > new Date().getTime()) {
        this.$message.warning("报名时间未到");
      } else if (
        this.classInfo.limitNum != 0 &&
        this.classInfo.limitNum != null &&
        num.data >= this.classInfo.limitNum
      ) {
        this.$message.warning("当前报名人数已满");
      } else {
        this.$router.push({ path: "/apply", query: { id: id } });
      }
    },
    // 对公汇款报名
    async applyCom(id) {
      console.log(this.classInfo.limitNum, "我是对公？？");
      let num = await api.queryAvailableNumByClassId(
        this.classInfo.classConfigId
      );
      if (!this.user) {
        this.$message.warning("请先登录后再报名");
      } else if (this.classInfo.applyEndTime < new Date().getTime()) {
        this.$message.warning("报名时间已过");
      } else if (this.classInfo.applyStartTime > new Date().getTime()) {
        this.$message.warning("报名时间未到");
      } else if (
        this.classInfo.limitNum != 0 &&
        this.classInfo.limitNum != null &&
        num.data >= this.classInfo.limitNum
      ) {
        this.$message.warning("当前报名人数已满");
      } else {
        this.$router.push({ path: "/Corporate", query: { id: id } });
      }
    },
  },
  created() {
    this.classId = this.$route.query.id;
    this.getClassForId(this.$route.query.id);
    this.getBxxxCourse(this.$route.query.id);
  },
};
</script>

<style lang="scss" scoped>
.container {
  margin: 20px 0px;
  .header {
    margin: 20px 0px;
    h3 {
      height: 25px;
      font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
      font-weight: 400;
      font-size: 18px;
      color: #333333;
      line-height: 25px;
      text-align: center;
      margin: 0px;
    }
  }

  .ors {
    display: flex;
    justify-content: center;
    .orsbox {
      width: 260px;
      height: 80px;
      cursor: pointer;
      span {
        display: block;
        margin: 20px;
        font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
        font-weight: 400;
        font-size: 18px;
        color: #264f99;
        text-align: left;
      }
    }
    .gbone {
      margin-right: 20px;
      background: url("../../assets/image/bianzhu (1).png");
    }
    .gbtwo {
      background: url("../../assets/image/bianzhu (2).png");
    }
  }

  .content {
    width: 1200px;
    margin: 0 auto;

    .class-detail {
      margin-top: 10px;
      text-align: center;
      background: #ffffff;
      padding: 20px;
      color: #646464;
      .desc {
        text-align: left;
        font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
        font-weight: 400;
        font-size: 14px;
        color: #666666;
        line-height: 20px;
        margin: 0px;
        margin-bottom: 20px;
      }
    }

    .class-course {
      margin: 20px 0px;
      padding-bottom: 0px;
      background: #ffffff;
      .class-course-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;

        .bxk {
          background: #264f99;
          height: 30px;
          width: 80px;
          border-radius: 1px;
          color: #ffffff;
          font-size: 14px;
          text-align: center;
          line-height: 30px;
          cursor: pointer;
          box-sizing: border-box;
        }

        .xxk {
          border: 1px solid #264f99;
          height: 30px;
          width: 80px;
          border-radius: 1px;
          color: #264f99;
          text-align: center;
          line-height: 30px;
          font-size: 14px;
          cursor: pointer;
          box-sizing: border-box;
        }
      }

      .class-course-content {
        display: grid;
        grid-template-columns: repeat(4, 1fr); /* 创建4列 */
        grid-gap: 0 20px; /* 设置列之间的间距（这里指右边距） */
        .item {
          width: 100%;
          overflow: hidden;
          margin-bottom: 20px;
          padding: 20px 20px 10px;
          position: relative;
          background: RGBA(241, 245, 250, 1);
          box-sizing: border-box;
          border-radius: 6px;
          cursor: pointer;
          p {
            font-size: 14px;
            font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
            font-weight: 400;
            color: #222222;
            line-height: 20px;
            height: 40px;
            margin: 0px 0px 8px;
            display: -webkit-box; /* 使用弹性布局盒子模型 */
            -webkit-line-clamp: 2; /* 设置最多显示3行 */
            -webkit-box-orient: vertical; /* 设置盒模型为垂直方向 */
            overflow: hidden;
          }
          .descs {
            height: 20px;
            font-size: 14px;
            font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
            font-weight: 400;
            color: #dc2326;
            line-height: 20px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            span:nth-of-type(2) {
              padding-left: 20px;
              color: #6727be;
              font-size: 18px;
            }
          }
        }
      }

      .xx {
        padding: 0 10px 10px;
      }
    }

    .study-lc {
      background: #f4f2ee;
      text-align: center;
    }
  }
  item .apply-footer {
    margin-top: 50px;
    background: linear-gradient(0deg, #0e0f34 0%, #12153d 49%, #0e1036 100%);
    height: 107px;
    margin-bottom: -10px;
    display: flex;
    justify-content: center;

    .apply {
      width: 1200px;
      padding: 10px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
}
.disabled {
  cursor: not-allowed;
  background: rgb(199, 194, 194);

  border: 1px solid #ac8384;
  height: 40px;
  width: 106px;
  border-radius: 1px;
  color: #ac8384;
  text-align: center;
  line-height: 42px;
}

.card {
  width: 1200px;
  background: #ffffff;
  padding: 24px 20px;
  box-sizing: border-box;
  .car-title {
    position: relative;
    text-align: left;
    padding-left: 8px;
    height: 22px;
    font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
    font-weight: 400;
    font-size: 16px;
    color: #264f99;
    line-height: 22px;
    text-align: justify;
    font-style: normal;
  }
  .car-title::before {
    content: "";
    width: 4px;
    height: 12px;
    background: #264f99;
    display: block;
    position: absolute;
    top: 6px;
    left: 0px;
  }
}

.lc {
  width: 1200px;
  margin: 0 auto;

  .ic-contain {
    display: flex;
    margin-top: 30px;
    align-items: center;
    .lc-item {
      width: 100%;
      height: 132px;
      background: #f6f7fb;
      border: 1px solid #eaeaeb;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      span {
        display: inline-block;
        margin-top: 16px;
      }
    }
    .jian {
      width: 28px;
      height: 10px;
      margin: 0px 10px;
    }
  }
}
</style>
